import {
  findList,
  applyForWebAuthority,
  getWebBanner,
  checkCollection,
  addCollection,
  removeCollection
} from '@/axios/api/homePage'

const UPDATE_LIST = 'UPDATE_LIST'
const UPDATE_WEB_BANNER_LIST = 'UPDATE_WEB_BANNER_LIST'

const state = {
  list: [],
  webBannerList: []
}

const getters = {
  list: state => state.list,
  webBannerList: state => state.webBannerList
}

const mutations = {
  [UPDATE_LIST] (state, list) {
    state.list = list
  },
  [UPDATE_WEB_BANNER_LIST] (state, webBannerList) {
    state.webBannerList = webBannerList
  }
}

const actions = {
  // 获取列表数据
  async findListApi ({ commit }, params) {
    try {
      const { data: res } = await findList(params)
      commit(UPDATE_LIST, res || [])
    } catch (e) {}
  },
  // 申请权限
  async applyForWebAuthorityApi ({ state, rootGetters }, params) {
    const { applyWindowType } = rootGetters['login/userInfo']
    const reqType = applyWindowType === 'subscribe' ? 'subscribe' : ''
    try {
      const res = await applyForWebAuthority({
        ...params,
        reqType
      })
      return res
    } catch (e) {
    }
  },
  // 获取WEB banner列表数据
  async getWebBannerApi ({ commit }, params) {
    try {
      const { data: res } = await getWebBanner(params)
      commit(UPDATE_WEB_BANNER_LIST, res.records || [])
    } catch (e) {
    }
  },
  // 检查是否收藏
  async checkCollectionApi ({ commit }, params) {
    try {
      const { data: res } = await checkCollection(params)
      return res
    } catch (e) {
    }
  },
  // 添加收藏
  async addCollectionApi ({ commit }, params) {
    try {
      const res = await addCollection(params)
      return res
    } catch (e) {
    }
  },
  // 取消收藏
  async removeCollectionApi ({ commit }, params) {
    try {
      const res = await removeCollection(params)
      return res
    } catch (e) {
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/homePage.js